export const termsAndConditionsContentAr = {
    title: "الشروط والأحكام",
    subtitle: "الشروط والأحكام لشركة Bitsclan لتقنية المعلومات",
    metaTitle: "الشروط والأحكام | المعلومات القانونية | حلول تكنولوجيا المعلومات من Bitsclan",
    intro:
        "مرحبًا بك في Bitsclan لتقنية المعلومات. من خلال الوصول إلى موقعنا الإلكتروني أو استخدام خدماتنا، فإنك توافق على الالتزام بالشروط والأحكام التالية. يرجى قراءة هذه الشروط بعناية. إذا كنت لا توافق على أي جزء من هذه الشروط، فلا يجب عليك استخدام خدماتنا.",
    sections: [
        {
            heading: "1. قبول الشروط",
            content:
                "باستخدامك لموقعنا وخدماتنا، فإنك توافق على الالتزام بهذه الشروط والأحكام، بالإضافة إلى سياسة الخصوصية الخاصة بنا. إذا كنت تستخدم خدماتنا نيابة عن مؤسسة، فإنك تقر بأن لديك الصلاحية لقبول هذه الشروط نيابةً عن تلك المؤسسة.",
        },
        {
            heading: "2. الخدمات المقدمة",
            content:
                "تقدم Bitsclan لتقنية المعلومات مجموعة من الخدمات تشمل الاستشارات التقنية، وتطوير البرمجيات، وحلول التسويق الرقمي. نحتفظ بالحق في تعديل أو تعليق أو إنهاء أي من خدماتنا وفقًا لتقديرنا الخاص دون إشعار مسبق.",
        },
        {
            heading: "3. مسؤوليات المستخدم",
            points: [
                {
                    label: "إنشاء الحساب",
                    description:
                        "إذا كان يتطلب منك إنشاء حساب للوصول إلى ميزات معينة، فإنك توافق على تقديم معلومات دقيقة وكاملة.",
                },
                {
                    label: "الاستخدامات المحظورة",
                    description:
                        "يُحظر عليك استخدام خدماتنا في أنشطة غير قانونية، بما في ذلك على سبيل المثال لا الحصر، الاحتيال، أو انتهاك حقوق الملكية الفكرية، أو الوصول غير المصرح به إلى الأنظمة.",
                },
            ],
        },
        {
            heading: "4. الملكية الفكرية",
            content:
                "جميع المحتويات الموجودة على موقعنا، بما في ذلك النصوص، والصور، والشعارات، والبرمجيات، والمواد الأخرى، هي ملك لشركة Bitsclan لتقنية المعلومات أو للمرخصين لها. لا يجوز لك نسخ أو تعديل أو توزيع أو استغلال هذه المحتويات بدون إذن كتابي صريح منا.",
        },
        {
            heading: "5. شروط الدفع",
            content:
                "بالنسبة لأي خدمات مدفوعة، فإنك توافق على تقديم معلومات فواتير دقيقة. يجب سداد المدفوعات كما هو موضح في الاتفاق أو الفاتورة. نحتفظ بالحق في تعليق أو إنهاء وصولك للخدمات إذا لم يتم الدفع في الوقت المحدد.",
        },
        {
            heading: "6. تحديد المسؤولية",
            content:
                "إلى أقصى حد يسمح به القانون، لن تكون شركة Bitsclan لتقنية المعلومات مسؤولة عن أي أضرار غير مباشرة أو عرضية أو تبعية تنشأ عن استخدامك لخدماتنا. وتقتصر مسؤوليتنا على المبلغ الذي دفعته مقابل الخدمات المعنية.",
        },
        {
            heading: "7. الخصوصية وجمع البيانات",
            content:
                "يخضع استخدامك لخدماتنا أيضًا لسياسة الخصوصية الخاصة بنا، والتي توضح كيفية جمع بياناتك الشخصية واستخدامها وحمايتها. باستخدامك لخدماتنا، فإنك توافق على جمع واستخدام بياناتك كما هو موضح في سياسة الخصوصية.",
        },
        {
            heading: "8. الإنهاء",
            content:
                "يجوز لنا إنهاء أو تعليق وصولك إلى خدماتنا في أي وقت دون إشعار، إذا قمت بانتهاك هذه الشروط والأحكام أو لأي سبب نراه مناسبًا. عند الإنهاء، يجب عليك التوقف فورًا عن استخدام خدماتنا.",
        },
        {
            heading: "9. القانون المعمول به",
            content:
                "تخضع هذه الشروط والأحكام وتفسر وفقًا لقوانين [الاختصاص القضائي]. ويتم حل أي نزاع حصريًا في محاكم [الاختصاص القضائي].",
        },
        {
            heading: "10. التغييرات على الشروط",
            content:
                "نحتفظ بالحق في تعديل هذه الشروط والأحكام في أي وقت. سيتم نشر أي تغييرات على هذه الصفحة مع تاريخ النفاذ المحدث. واستمرار استخدامك لخدماتنا بعد هذه التغييرات يُعد قبولًا للشروط المحدثة.",
        },
        {
            heading: "11. اتصل بنا",
            content:
                "إذا كانت لديك أي أسئلة بخصوص هذه الشروط والأحكام، يرجى التواصل معنا عبر:",
            contact: {
                emailHeading: "البريد الإلكتروني",
                email: "hello@bitsclan.com",
                phoneHeading: "رقم الهاتف",
                phone: "+1 315 666 8052",
                addresHeading: "العنوان",
                address: "الطابق العشرون، 2 Park Ave، نيويورك، NY 10016",
            },
        },
    ],
};